/* unplugin-vue-components disabled */import script from "./admin-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./admin-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./admin-dialog.vue?vue&type=style&index=0&id=1b8b7856&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8b7856"]])

export default __exports__